import { Link } from 'react-router-dom';
export default function Forbidden() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg text-text-primary">
      <h1 className="text-3xl font-bold text-primary">403 — Forbidden</h1>
      <p className="text-text-muted mt-2">You don't have access to this area.</p>
      <Link to="/login" className="mt-4 text-primary hover:underline">Back to login</Link>
    </div>
  );
}
